import * as tslib_1 from "tslib";
import { Image2D } from "../image/Image2D";
/**

 */
var ExternalImage2D = (function (_super) {
    tslib_1.__extends(ExternalImage2D, _super);
    /**
     *
     */
    function ExternalImage2D(urlRequest) {
        var _this = _super.call(this, 8, 8, true) || this;
        _this._urlRequest = urlRequest;
        return _this;
    }
    Object.defineProperty(ExternalImage2D.prototype, "assetType", {
        /**
         *
         * @returns {string}
         */
        get: function () {
            return ExternalImage2D.assetType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExternalImage2D.prototype, "urlRequest", {
        get: function () {
            return this._urlRequest;
        },
        set: function (value) {
            this._urlRequest = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a new ExternalImage2D object that is a clone of the original instance
     * with an exact copy of the contained bitmap.
     *
     * @return A new ExternalImage2D object that is identical to the original.
     */
    ExternalImage2D.prototype.clone = function () {
        var t = new ExternalImage2D(this._urlRequest);
        return t;
    };
    return ExternalImage2D;
}(Image2D));
export { ExternalImage2D };
ExternalImage2D.assetType = "[image ExternalImage2D]";



// WEBPACK FOOTER //
// ../dist/lib/image/ExternalImage2D.js